// Dominican Republic listing data — shared between grid and detail pages

// Habitat Beach Garden images
import hbgExt1 from "@/assets/bg-exterior-1.jpg";
import hbgExt2 from "@/assets/bg-exterior-2.jpg";
import hbgExt3 from "@/assets/bg-exterior-3.jpg";
import hbgExt4 from "@/assets/bg-exterior-4.jpg";
import hbgExt5 from "@/assets/bg-exterior-5.jpg";
import hbg01 from "@/assets/bg-01.jpg";
import hbg02 from "@/assets/bg-02.jpg";
import hbg03 from "@/assets/bg-03.jpg";
import hbgEntrada from "@/assets/bg-entrada.jpg";
import hbgTerraza from "@/assets/bg-terraza.jpg";
import hbgInt1 from "@/assets/bg-interior-1.jpg";
import hbgInt2 from "@/assets/bg-interior-2.jpg";
import hbgSala2 from "@/assets/bg-sala-2.jpg";
import hbgSala3 from "@/assets/bg-sala-3.jpg";
import hbgR01 from "@/assets/bg-r01.jpg";
import hbgR02 from "@/assets/bg-r02.jpg";
import hbgR03 from "@/assets/bg-r03.jpg";
import hbgR05 from "@/assets/bg-r05.jpg";
import hbgR06 from "@/assets/bg-r06.jpg";

// Habitat Beach Tower images
import hbtExt1 from "@/assets/bt-exterior-01.jpg";
import hbtExt2 from "@/assets/bt-exterior-02.jpg";
import hbtLobby from "@/assets/bt-lobby.jpg";
import hbtPool from "@/assets/bt-social-pool.jpg";
import hbtTables from "@/assets/bt-social-tables.jpg";
import hbtRestaurant from "@/assets/bt-ref-restaurant-coworking.jpg";
import hbtR01 from "@/assets/bt-r01-2.jpg";
import hbtR02 from "@/assets/bt-r02-2.jpg";
import hbtR03 from "@/assets/bt-r03-2.jpg";
import hbtR04 from "@/assets/bt-r04.jpg";
import hbtR05 from "@/assets/bt-r05-2.jpg";
import hbtR06 from "@/assets/bt-r06-2.jpg";
import hbtR07 from "@/assets/bt-r07.jpg";
import hbtR08 from "@/assets/bt-r08.jpg";
import hbtR09 from "@/assets/bt-r09.jpg";
import hbtR10 from "@/assets/bt-r10.jpg";
import hbtR11 from "@/assets/bt-r11.jpg";
import hbtR12 from "@/assets/bt-r12.jpg";
import hbtR13 from "@/assets/bt-r13.jpg";
import hbtR17 from "@/assets/bt-r17.jpg";
import hbtR18 from "@/assets/bt-r18.jpg";
import hbtR19 from "@/assets/bt-r19.jpg";

import tc01 from "@/assets/travieso-cabarete/tc-01.png";
import tc02 from "@/assets/travieso-cabarete/tc-02.png";
import tc03 from "@/assets/travieso-cabarete/tc-03.png";
import tc04 from "@/assets/travieso-cabarete/tc-04.png";
import tc05 from "@/assets/travieso-cabarete/tc-05.png";
import tc06 from "@/assets/travieso-cabarete/tc-06.png";
import tc07 from "@/assets/travieso-cabarete/tc-07.png";
import tc08 from "@/assets/travieso-cabarete/tc-08.png";
import tc09 from "@/assets/travieso-cabarete/tc-09.png";
import tc10 from "@/assets/travieso-cabarete/tc-10.png";
import tc11 from "@/assets/travieso-cabarete/tc-11.png";
import tc12 from "@/assets/travieso-cabarete/tc-12.png";
import tc13 from "@/assets/travieso-cabarete/tc-13.png";
import tc14 from "@/assets/travieso-cabarete/tc-14.png";
import tc15 from "@/assets/travieso-cabarete/tc-15.png";
import tc16 from "@/assets/travieso-cabarete/tc-16.png";
import tc17 from "@/assets/travieso-cabarete/tc-17.png";
import tc18 from "@/assets/travieso-cabarete/tc-18.png";

import gv01 from "@/assets/god-view-cabrera/gv-01.jpg";
import gv02 from "@/assets/god-view-cabrera/gv-02.jpg";
import gv03 from "@/assets/god-view-cabrera/gv-03.jpg";
import gv04 from "@/assets/god-view-cabrera/gv-04.jpg";
import gv05 from "@/assets/god-view-cabrera/gv-05.jpg";
import gv06 from "@/assets/god-view-cabrera/gv-06.jpg";
import gv07 from "@/assets/god-view-cabrera/gv-07.jpg";
import gv08 from "@/assets/god-view-cabrera/gv-08.jpg";
import gv09 from "@/assets/god-view-cabrera/gv-09.jpg";
import gv10 from "@/assets/god-view-cabrera/gv-10.jpg";
import gv11 from "@/assets/god-view-cabrera/gv-11.jpg";
import gv12 from "@/assets/god-view-cabrera/gv-12.jpg";
import gv13 from "@/assets/god-view-cabrera/gv-13.jpg";
import gv14 from "@/assets/god-view-cabrera/gv-14.jpg";
import gv15 from "@/assets/god-view-cabrera/gv-15.jpg";
import gv16 from "@/assets/god-view-cabrera/gv-16.jpg";
import gv17 from "@/assets/god-view-cabrera/gv-17.jpg";
import gv18 from "@/assets/god-view-cabrera/gv-18.jpg";
import gv19 from "@/assets/god-view-cabrera/gv-19.jpg";
import gv20 from "@/assets/god-view-cabrera/gv-20.jpg";
import gv21 from "@/assets/god-view-cabrera/gv-21.jpg";
import gv22 from "@/assets/god-view-cabrera/gv-22.jpg";

import la01 from "@/assets/los-almendros/la-01.png";
import la02 from "@/assets/los-almendros/la-02.png";
import la03 from "@/assets/los-almendros/la-03.png";
import la04 from "@/assets/los-almendros/la-04.png";
import la05 from "@/assets/los-almendros/la-05.png";
import la06 from "@/assets/los-almendros/la-06.png";
import la07 from "@/assets/los-almendros/la-07.png";
import la08 from "@/assets/los-almendros/la-08.png";
import la09 from "@/assets/los-almendros/la-09.png";
import la10 from "@/assets/los-almendros/la-10.png";
import la11 from "@/assets/los-almendros/la-11.png";

import vl01 from "@/assets/vistas-del-limonal/vl-01.png";
import vl02 from "@/assets/vistas-del-limonal/vl-02.png";
import vl03 from "@/assets/vistas-del-limonal/vl-03.png";
import vl04 from "@/assets/vistas-del-limonal/vl-04.png";
import vl05 from "@/assets/vistas-del-limonal/vl-05.png";
import vl06 from "@/assets/vistas-del-limonal/vl-06.png";
import vl07 from "@/assets/vistas-del-limonal/vl-07.png";
import vl08 from "@/assets/vistas-del-limonal/vl-08.png";
import vl09 from "@/assets/vistas-del-limonal/vl-09.png";
import vl10 from "@/assets/vistas-del-limonal/vl-10.png";
import vl11 from "@/assets/vistas-del-limonal/vl-11.png";
import vl12 from "@/assets/vistas-del-limonal/vl-12.png";
import vl13 from "@/assets/vistas-del-limonal/vl-13.png";
import vl14 from "@/assets/vistas-del-limonal/vl-14.png";
import vl15 from "@/assets/vistas-del-limonal/vl-15.png";
import vl16 from "@/assets/vistas-del-limonal/vl-16.png";

export interface DRListing {
  slug: string;
  status: string;
  tag: string;
  price: string;
  priceNote?: string;
  name: string;
  location: string;
  type: string;
  beds: string;
  baths: number;
  sqft: string;
  images: string[];
  description: string[];
  features: string[];
  details: { label: string; value: string }[];
  investment: {
    rentalYield: string;
    occupancyRate: string;
    estAnnualReturn: string;
    nearbyAmenities: { name: string; distance: string }[];
  };
}

const drListings: DRListing[] = [
  {
    slug: "habitat-beach-garden-juan-dolio",
    status: "Available",
    tag: "Beachfront",
    price: "Contact for Pricing",
    name: "Habitat Beach Garden",
    location: "Boulevard Juan Dolio, Guayacanes, San Pedro de Macorís, DR",
    type: "Residential Development",
    beds: "2",
    baths: 2,
    sqft: "97–156",
    images: [hbgExt1, hbg01, hbgExt2, hbgExt3, hbg03, hbgTerraza, hbgEntrada, hbgInt1, hbgInt2, hbgSala2, hbgSala3, hbgR01, hbgR02, hbgR03, hbgR05, hbgR06, hbgExt4, hbgExt5, hbg02],
    description: [
      "Beach Garden is a boutique residential development by Cuadro Arquitectura, located on Boulevard Juan Dolio in Guayacanes, San Pedro de Macorís. Spread across a 10,058 m² plot with three blocks (A, B, C) of approximately 54 units, the project is designed for buyers and investors who want both lifestyle and returns in one of the Caribbean's fastest-growing coastal corridors.",
      "All units are 2-bedroom, 2-bathroom with walk-in closets, private terraces, modular kitchens, and high-end imported finishes throughout. First-floor Tipo 1 units (102 m²) include exclusive swim-up pool access and a private patio. Tipo 3 penthouse units (156 m² total) add a private rooftop terrace with social area, jacuzzi, and bathroom on the 4th floor.",
      "Cuadro Arquitectura brings 10+ years of experience and 250+ residential units developed in the eastern DR — with a portfolio including Habitat Residences, Habitat Lake, Habitat Ocean, and Habitat Beach Tower. The payment plan requires just $2,000 USD to reserve, with 10% at signing, 30% during construction, and 60% at delivery.",
    ],
    features: [
      "Main pool + swim-up pool",
      "Co-working space",
      "Casa club with gazebo and BBQ",
      "Gym",
      "Padel court",
      "Jogging track",
      "Yoga corner",
      "Children's playground",
      "Pet park",
      "\"The Beach\" area",
      "Private terraces on all units",
      "1st-floor units with swim-up pool + private patio",
      "Penthouse units with private rooftop terrace and jacuzzi",
      "Modular kitchen with built-in appliances",
      "Electronic lock on main door",
      "Imported porcelain tile flooring",
      "Black aluminum window frames + glass shower enclosures",
      "Vehicular parking",
      "3 min from restaurants",
    ],
    details: [
      { label: "Developer", value: "Cuadro Arquitectura SRL" },
      { label: "Property Type", value: "Residential Development" },
      { label: "Total Units", value: "~54 units across 3 blocks" },
      { label: "Tipo 1 (1st floor)", value: "102 m² · 2BR/2BA + swim-up pool + patio" },
      { label: "Tipo 2 (2nd floor)", value: "97.15 m² · 2BR/2BA" },
      { label: "Tipo 3 (Penthouse)", value: "156 m² total · 2BR/2BA + rooftop terrace + jacuzzi" },
      { label: "Location", value: "Boulevard Juan Dolio, Guayacanes, SPM, DR" },
      { label: "Plot Size", value: "10,058 m²" },
      { label: "Payment Plan", value: "$2,000 reserve · 10% signing · 30% construction · 60% delivery" },
    ],
    investment: {
      rentalYield: "Contact for details",
      occupancyRate: "Contact for details",
      estAnnualReturn: "Contact for details",
      nearbyAmenities: [
        { name: "Juan Dolio Beach", distance: "Steps away" },
        { name: "Restaurants & Shopping", distance: "3 min" },
        { name: "PGA Oceans 4 Golf Course", distance: "20 min" },
        { name: "Las Américas International Airport (SDQ)", distance: "30 min" },
        { name: "Santo Domingo", distance: "40 min" },
      ],
    },
  },
  {
    slug: "habitat-beach-tower-juan-dolio",
    status: "Available",
    tag: "Ocean View",
    price: "Contact for Pricing",
    name: "Habitat Beach Tower",
    location: "Juan Dolio, San Pedro de Macorís, Dominican Republic",
    type: "Luxury Tower",
    beds: "Studio–2",
    baths: 2,
    sqft: "45–93",
    images: [hbtExt1, hbtExt2, hbtLobby, hbtPool, hbtTables, hbtR01, hbtR02, hbtR03, hbtR04, hbtR05, hbtR06, hbtR07, hbtR08, hbtR09, hbtR10, hbtR11, hbtR12, hbtR13, hbtR17, hbtR18, hbtR19, hbtRestaurant],
    description: [
      "Habitat Beach Tower is a 14-level oceanfront tower in Juan Dolio by Cuadro Arquitectura — just 450 meters from the beach with a 5-minute walk to Hemingway Beach. With 62 units across 12 residential floors, every apartment faces south, southwest, or southeast, ensuring all units have ocean views.",
      "The tower offers five unit types per floor: compact Type C studios (45 m²), one-bedroom Type A/E units (64 m²), and two-bedroom Type B/D residences (93 m²). All units include private balconies, imported porcelain floors, modular kitchens with built-in appliances, electronic door locks, and glass-enclosed bathrooms.",
      "The first two levels are dedicated to community living — a grand lobby and commercial space on level 1, and a full social amenity floor on level 2 including pool, bar/lounge, gym, kids area, co-working space, and terrace. Cuadro Arquitectura brings the same premium finishes and construction quality from their 250+ unit portfolio across the eastern Dominican Republic.",
    ],
    features: [
      "14-level tower, 62 total units",
      "All units have ocean views (south, SW, SE)",
      "450m from beach — 5 min walk to Hemingway Beach",
      "Pool and social terrace (level 2)",
      "Bar and lounge",
      "Gym",
      "Co-working space",
      "Kids area",
      "Commercial space and meeting room (level 1)",
      "Grand lobby with elevators",
      "Private balconies on all units",
      "Modular kitchen with built-in appliances",
      "Imported porcelain tile flooring",
      "Electronic lock on main door",
      "Glass shower enclosures",
      "1 min from Banco Popular",
      "2 min from Juan Dolio International School",
    ],
    details: [
      { label: "Developer", value: "Cuadro Arquitectura SRL" },
      { label: "Building", value: "14 levels · 62 units · 5 per floor (levels 3–14)" },
      { label: "Type A/E (1BR)", value: "64 m² · 1 bed / 1 bath · balcony" },
      { label: "Type B/D (2BR)", value: "93 m² · 2 beds / 2 baths · balcony" },
      { label: "Type C (Studio)", value: "45 m² · studio / 1 bath" },
      { label: "Location", value: "Juan Dolio, San Pedro de Macorís, DR" },
      { label: "Beach Distance", value: "450 m (5 min walk)" },
      { label: "Payment Plan", value: "$2,000 reserve · 10% signing · 30% construction · 60% delivery" },
    ],
    investment: {
      rentalYield: "Contact for details",
      occupancyRate: "Contact for details",
      estAnnualReturn: "Contact for details",
      nearbyAmenities: [
        { name: "Hemingway Beach", distance: "5 min walk" },
        { name: "Banco Popular", distance: "1 min" },
        { name: "Juan Dolio International School", distance: "2 min" },
        { name: "Las Américas International Airport (SDQ)", distance: "30 min" },
        { name: "Santo Domingo", distance: "40 min" },
      ],
    },
  },
  {
    slug: "travieso-cabarete-beach-apartments",
    status: "Available",
    tag: "Beachfront",
    price: "From $175,750 USD",
    priceNote: "≈ RD$10,545,000 DOP",
    name: "Travieso Cabarete – Beach Apartments",
    location: "Cabarete, Puerto Plata, Dominican Republic",
    type: "Apartment",
    beds: "1–3",
    baths: 2,
    sqft: "57–233",
    images: [tc01, tc02, tc03, tc04, tc05, tc06, tc07, tc08, tc09, tc10, tc11, tc12, tc13, tc14, tc15, tc16, tc17, tc18],
    description: [
      "Travieso Cabarete is a beachfront investment development located directly on the Cabarete–Puerto Plata highway — one of the fastest-growing tourist corridors in the Caribbean. Designed from the ground up for vacation rental income, this project is engineered to produce returns from day one.",
      "Cabarete is an international magnet for surfing, beaches, and active tourism 365 days a year. With a high-spending global community and just 20 minutes from Puerto Plata Airport, the area maintains constant occupancy and growing demand for short-term rentals. Projected annual growth runs between 8% and 12%, backed by developers with over 150 successful projects.",
      "The development offers a unique combination of residential, commercial, and tourist experience — a shopping plaza, vibrant atmosphere, and a constant flow of visitors that turns your property into an income-generating asset. Available unit types range from compact high-turnover studios to premium oceanfront residences, including the Kite (57 m²), Coco (79 m²), Surf (100 m²), Wave (157 m²), and Ocean (233 m²) models.",
    ],
    features: [
      "Prime beachfront location on Cabarete highway",
      "Designed for vacation rentals and immediate return",
      "Tax incentives available for investors",
      "Backed by developers with 150+ completed projects",
      "Residential + commercial + tourist experience concept",
      "Pool, jacuzzi, and shared terrace",
      "Gym and tennis court",
      "24-hour security and electric gate",
      "Beach access from the property",
      "Short-term rentals permitted",
      "Pets allowed",
      "Children's area and event hall",
      "Air conditioning and digital locks",
      "Ocean and mountain views",
      "Gated community",
    ],
    details: [
      { label: "Property Type", value: "Apartment" },
      { label: "Unit Models", value: "Kite · Coco · Surf · Wave · Ocean" },
      { label: "Bedrooms", value: "1–3 BR (by unit)" },
      { label: "Bathrooms", value: "1.5–4 baths (by unit)" },
      { label: "Size Range", value: "57–233 m²" },
      { label: "Location", value: "Cabarete, Puerto Plata, DR" },
      { label: "Development Status", value: "Under Construction" },
      { label: "Reference", value: "EB-VW8648" },
    ],
    investment: {
      rentalYield: "8–12%",
      occupancyRate: "75%",
      estAnnualReturn: "8–12% (projected growth)",
      nearbyAmenities: [
        { name: "Cabarete Beach", distance: "Steps away" },
        { name: "Kite Beach", distance: "5 min" },
        { name: "Puerto Plata Airport (POP)", distance: "20 min" },
        { name: "Cabarete Town Center", distance: "5 min" },
        { name: "Ocean World Marina", distance: "25 min" },
      ],
    },
  },
  {
    slug: "god-view-oceanfront-apartments-cabrera",
    status: "Pre-Construction",
    tag: "Oceanfront",
    price: "From $83,601 USD",
    priceNote: "≈ RD$5,016,000 DOP",
    name: "God View – Oceanfront Apartments",
    location: "Cabrera, María Trinidad Sánchez, Dominican Republic",
    type: "Apartment",
    beds: "1–3",
    baths: 1,
    sqft: "46–250",
    images: [gv01, gv02, gv03, gv04, gv05, gv06, gv07, gv08, gv09, gv10, gv11, gv12, gv13, gv14, gv15, gv16, gv17, gv18, gv19, gv20, gv21, gv22],
    description: [
      "God View is a boutique oceanfront development in Cabrera — one of the Dominican Republic's most unspoiled and rapidly growing coastal destinations. With only 84 units across buildings of just 3 levels, this project is built for exclusivity, privacy, and strong vacation rental returns.",
      "Every unit comes with an ocean view. The development is strategically designed for the short-term rental market, with an infinity pool, paddle tennis court, equipped gym, and children's area — all the amenities that drive Airbnb demand and maximize occupancy. Penthouses include private jacuzzis, pergolas, and BBQ pre-installations.",
      "Currently in pre-sale at the lowest pricing in the project's lifecycle, God View is backed by a trust with FIDUCORP for full investor protection. Reserve today with just $2,000 USD, with staged payments of 10% at signing, 40% during construction, and 50% at delivery. Scheduled for completion in Q3 2028.",
    ],
    features: [
      "100% ocean view units",
      "Only 84 units — limited availability",
      "3-level buildings for privacy and exclusivity",
      "Infinity pool",
      "Equipped gym",
      "Paddle tennis court",
      "Children's area",
      "24-hour security and access control",
      "Pet-friendly",
      "Short-term rentals permitted",
      "Penthouse units with private jacuzzi and pergola",
      "Backed by FIDUCORP trust",
      "Gated community with parking",
      "Mountain and ocean views",
      "Common gas and power plant",
    ],
    details: [
      { label: "Property Type", value: "Apartment" },
      { label: "Bedrooms", value: "1, 2, or 3 BR" },
      { label: "Bathrooms", value: "1–3 baths (by unit)" },
      { label: "Size Range", value: "46–250 m²" },
      { label: "Location", value: "Cabrera, María Trinidad Sánchez, DR" },
      { label: "Development Status", value: "Pre-Construction" },
      { label: "Expected Delivery", value: "Q3 2028" },
      { label: "Reference", value: "EB-VW5498" },
    ],
    investment: {
      rentalYield: "8–12%",
      occupancyRate: "70%",
      estAnnualReturn: "10–15% (incl. appreciation)",
      nearbyAmenities: [
        { name: "Cabrera Beach", distance: "Steps away" },
        { name: "Cabrera Town Center", distance: "5 min" },
        { name: "Nagua", distance: "30 min" },
        { name: "Gregorio Luperón International Airport (POP)", distance: "1.5 hrs" },
        { name: "El Catey International Airport (AZS)", distance: "45 min" },
      ],
    },
  },
  {
    slug: "los-almendros-residential-complex-bani",
    status: "Pre-Construction",
    tag: "Residential",
    price: "$83,300 USD",
    priceNote: "RD$5,000,000 DOP",
    name: "Los Almendros Residential Complex",
    location: "Baní, Peravia, Dominican Republic",
    type: "Apartment & Townhouse",
    beds: "2–3",
    baths: 2,
    sqft: "69–250",
    images: [la01, la02, la03, la04, la05, la06, la07, la08, la09, la10, la11],
    description: [
      "Los Almendros Residential Complex is a modern gated development in Boca Canasta, Baní — a strategic location with direct access from Avenida Fabio Herrera and the new Baní Ring Road. The project integrates apartments and townhouses in an environment designed for security, comfort, and family living.",
      "The complex offers a full suite of amenities including a clubhouse, swimming pools, outdoor gym, sports areas, gazebos, BBQ area, and 24-hour security. Paved streets, landscaping, and green areas throughout the community create a peaceful residential atmosphere ideal for families.",
      "Available unit types include Type A (85 m², 3BR/2BA), Type B (98 m², 3BR/2BA), and Type C (69 m², 2BR/2BA) apartments — all with penthouse options featuring private terraces of 32–49 m². Townhouses offer 120 m² across two levels with private patios and exclusive outdoor areas from 43 to 80 m². Reserve with only US$500.",
    ],
    features: [
      "Clubhouse and event areas",
      "Swimming pools",
      "Outdoor gym and sports areas",
      "Gazebos and BBQ area",
      "Paved streets and landscaping",
      "24-hour security",
      "Gated community with controlled access",
      "Penthouse units with private terraces",
      "Townhouse units with private patio",
      "Direct access from Avenida Fabio Herrera",
      "New Baní Ring Road connectivity",
      "Reserve with only US$500",
    ],
    details: [
      { label: "Property Type", value: "Apartment & Townhouse" },
      { label: "Unit Types", value: "Type A (85m²) · Type B (98m²) · Type C (69m²)" },
      { label: "Bedrooms", value: "2–3 BR (by unit)" },
      { label: "Bathrooms", value: "2 baths" },
      { label: "Townhouse Size", value: "120 m² on 2 levels" },
      { label: "Location", value: "Boca Canasta, Baní, Peravia, DR" },
      { label: "Development Status", value: "Under Construction" },
      { label: "Reference", value: "EB-VW3139" },
    ],
    investment: {
      rentalYield: "6–9%",
      occupancyRate: "65%",
      estAnnualReturn: "8–12% (incl. appreciation)",
      nearbyAmenities: [
        { name: "Baní City Center", distance: "10 min" },
        { name: "Avenida Fabio Herrera", distance: "Direct access" },
        { name: "Baní Beach (Playa Palenque)", distance: "20 min" },
        { name: "Las Américas International Airport (SDQ)", distance: "1 hr" },
        { name: "Santo Domingo", distance: "1 hr 15 min" },
      ],
    },
  },
  {
    slug: "vistas-del-limonal-residential-complex-santiago",
    status: "Pre-Construction",
    tag: "Residential",
    price: "$86,000 USD",
    priceNote: "≈ RD$5,160,000 DOP",
    name: "Vistas Del Limonal Residential Complex",
    location: "Licey al Medio, Santiago, Dominican Republic",
    type: "Apartment",
    beds: "3",
    baths: 2,
    sqft: "89–123",
    images: [vl01, vl02, vl03, vl04, vl05, vl06, vl07, vl08, vl09, vl10, vl11, vl12, vl13, vl14, vl15, vl16],
    description: [
      "Vistas del Limonal is a gated residential community in Limonal Arriba, Santiago de los Caballeros — designed as a private resort where family safety and lifestyle take center stage. With 24/7 security and controlled access, the complex delivers a comprehensive living experience in one of the DR's most vibrant cities.",
      "Resort-style amenities include a clubhouse with event hall and game room, private gym, sports courts, swimming pool, playgrounds, and expansive green areas. The project is built for families seeking comfort, recreation, and security without leaving the community.",
      "Available units include the Comfort Model (89 m², levels 1–3) featuring a private balcony, semi-open kitchen, and separate laundry area, and the Penthouse Model (level 4) with a family room, full bath on the upper level, and a 34.26 m² private terrace. Reserve with just US$500, with delivery projected for June 2028.",
    ],
    features: [
      "24/7 security and controlled access",
      "Clubhouse with event hall and game room",
      "Private gym and sports courts",
      "Swimming pool",
      "Playgrounds and green areas",
      "Penthouse units with private terrace (34.26 m²)",
      "Private balcony on all units",
      "Semi-open modern kitchen",
      "Separate laundry area",
      "Electric gate",
      "Pets allowed",
      "Short-term rentals permitted",
      "Mountain views",
      "Reserve with only US$500",
    ],
    details: [
      { label: "Property Type", value: "Apartment" },
      { label: "Unit Models", value: "Comfort (89 m²) · Penthouse (89 m² + 34 m² terrace)" },
      { label: "Bedrooms", value: "3 bedrooms" },
      { label: "Bathrooms", value: "2 baths" },
      { label: "Location", value: "Licey al Medio, Santiago, DR" },
      { label: "Development Status", value: "Under Construction" },
      { label: "Expected Delivery", value: "June 2028" },
      { label: "Reference", value: "EB-VV4838" },
    ],
    investment: {
      rentalYield: "6–9%",
      occupancyRate: "65%",
      estAnnualReturn: "8–11% (incl. appreciation)",
      nearbyAmenities: [
        { name: "Licey al Medio Town", distance: "5 min" },
        { name: "Santiago de los Caballeros", distance: "15 min" },
        { name: "Cibao International Airport (STI)", distance: "20 min" },
        { name: "Shopping & Dining", distance: "10 min" },
        { name: "Puerto Plata", distance: "1 hr" },
      ],
    },
  },
];

export default drListings;
